import React from 'react';
interface BrowserShotProps {
  src: string;
  alt: string;
  /** Interactive layers placed over the screenshot. */
  children?: React.ReactNode;
}

/**
 * Presents a supplied website screenshot in a clean, neutral browser frame.
 * The screenshot's own browser chrome is cropped away.
 */
export function BrowserShot({
  src,
  alt,
  children
}: BrowserShotProps) {
  return <div className="overflow-hidden rounded-[18px] bg-white shadow-[0_40px_80px_-44px_rgba(1,51,43,0.55)] ring-1 ring-[rgba(1,51,43,0.1)]" data-id="element-78" data-mp="1mfyv6jy3ypyz">
      <div className="flex items-center gap-3 border-b border-[rgba(1,51,43,0.08)] px-4 py-2.5" data-id="element-79" data-mp="1hhxdo3gbyypm">
        <div className="flex gap-1.5" aria-hidden="true" data-id="element-80" data-mp="1vhpzbkd02oqq">
          <span className="h-2.5 w-2.5 rounded-full bg-[rgba(1,51,43,0.14)]" data-id="element-81" data-mp="1qhk3rt3m0i3d" />
          <span className="h-2.5 w-2.5 rounded-full bg-[rgba(1,51,43,0.14)]" data-id="element-82" data-mp="1qjoht3v82xhd" />
          <span className="h-2.5 w-2.5 rounded-full bg-[rgba(1,51,43,0.14)]" data-id="element-83" data-mp="36u8wsvdpqjva" />
        </div>
        <span className="truncate rounded-full bg-[#F4F2EC] px-3 py-1 font-body text-[10.5px] text-[rgba(1,51,43,0.55)]" data-id="element-84" data-mp="31vxowq6zajfp">
          info.engage.solventum.com/filtek_family
        </span>
      </div>
      <div className="relative overflow-hidden" style={{
      aspectRatio: '2576 / 1322'
    }} data-id="element-85" data-mp="2h8xmrc8ljg6n">
        <img src={src} alt={alt} className="block w-full" style={{
        marginTop: '-4.8%'
      }} data-id="element-86" data-mp="2mad8l6illqq3" />
        {children}
      </div>
    </div>;
}